import Vue from 'vue'
import Vuex from 'vuex'
import hardwareHome from './hardwareHome'
import hardwareRefund from './hardwareRefund'
import goodsBank from './goodsBank'
import loan from './loan'
import user from './user'
import active from './active'
import orderFilter from './orderFilter'
import activityPreview from './activityPreview'
import activityState from './activityState'
import clientAddFriend from './clientAddFriend'
import thirdDelivery from './thirdDelivery'
import common from './common'
import coupon from './coupon'
import editStoreInfo from './editStoreInfo'
import shopDecoration from './shopDecoration'
import depositOrderFilter from './depositOrderFilter'
import groupBuy from './groupBuy' // 团购
import questionnaire from './questionnaire' // 活动报名
import teachTrain from './teachTrain' // 教培
import teachAssistant from './teachAssistant'
import riskAppeal from './riskAppeal'
import stateSubsidies from './stateSubsidies'
// import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)
// const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    hardwareHome,
    hardwareRefund,
    loan,
    user,
    active,
    goodsBank,
    orderFilter,
    activityPreview,
    activityState,
    clientAddFriend,
    common,
    coupon,
    editStoreInfo,
    thirdDelivery,
    shopDecoration,
    depositOrderFilter,
    groupBuy,
    teachTrain,
    teachAssistant,
    riskAppeal,
    questionnaire,
    stateSubsidies
  }
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
})
